import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SectionCard } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const CHANNELS = [
  { key: "email", label: "E-posta almak istiyorum" },
  { key: "sms", label: "SMS almak istiyorum" },
  { key: "whatsapp", label: "WhatsApp mesajı almak istiyorum" },
  { key: "phone", label: "Telefonla aranmak istiyorum" },
];

const pick = (cc) => Object.fromEntries(CHANNELS.map(({ key }) => [key, Boolean(cc?.[key])]));

export const ContactPreferencesCard = () => {
  const { user, checkAuth } = useAuth();
  const [initial, setInitial] = useState(() => pick(user?.contact_consent));
  const [prefs, setPrefs] = useState(initial);
  const [saving, setSaving] = useState(false);
  const dirty = CHANNELS.some(({ key }) => prefs[key] !== initial[key]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/contact-consent", prefs);
      const saved = pick(data.contact_consent);
      setInitial(saved);
      setPrefs(saved);
      toast.success("İletişim tercihleriniz kaydedildi");
      await checkAuth?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Tercihler kaydedilemedi");
    } finally { setSaving(false); }
  };

  return (
    <SectionCard title="İletişim Tercihleri">
      <div className="p-5 space-y-4" data-testid="contact-preferences-card">
        <div className="divide-y divide-slate-100">
          {CHANNELS.map(({ key, label }) => (
            <label key={key} className="flex items-center justify-between gap-4 py-3 cursor-pointer">
              <span className="text-sm text-slate-800">{label}</span>
              <Switch
                checked={prefs[key]}
                onCheckedChange={(v) => setPrefs((p) => ({ ...p, [key]: v }))}
                data-testid={`contact-pref-${key}-switch`}
              />
            </label>
          ))}
        </div>
        <div className="text-xs text-slate-500 leading-relaxed">
          Hesabınız ve Penz hizmetinin kullanımıyla ilgili zorunlu bilgilendirmeler bu tercihlerden etkilenmez.
        </div>
        <div className="flex justify-end">
          <Button
            type="button"
            onClick={save}
            disabled={!dirty || saving}
            className="bg-slate-900 hover:bg-slate-800"
            data-testid="contact-pref-save-button"
          >
            {saving ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </div>
      </div>
    </SectionCard>
  );
};

export default ContactPreferencesCard;
